export default "__VITE_ASSET__DPm_D8dg__"